module.exports = __webpack_public_path__ + "static/media/talksCardBackAlt.3fa54242.svg";